import projectSubTasksApi from '@/api/projectSubTasks';

const state = {
  projectSubTasks: [],
  projectSubTask: {},
  filteredProjectSubTasks: [],
};

export const actions = {
  getList({ commit }) {
    projectSubTasksApi.getProjectSubTasks().then((data) => {
      commit('projectSubTasks', data.projectSubTasks);
    });
  },

  get({ commit }, arg) {
    projectSubTasksApi.getProjectSubTask(arg).then((data) => {
      commit('projectSubTask', data.projectSubTask);
    });
  },

  getListByProject({ commit }, arg) {
    projectSubTasksApi.getListByProject(arg).then((data) => {
      commit('filteredProjectSubTasks', data.projectSubTasks);
    });
  },

  search({ commit }, arg) {
    projectSubTasksApi.searchProjectSubTask(arg).then((data) => {
      commit('projectSubTasks', data.projectSubTasks);
    });
  },

  save({ commit }, args) {
    projectSubTasksApi.saveProjectSubTask(args).then((data) => {
      commit('projectSubTasks', data.projectSubTasks);
      commit(
        'alert/add',
        {
          title: 'Informations',
          message: 'La tâche été modifiée avec succès!',
          variant: 'success',
          icon: 'check_circle',
        },
        { root: true },
      );
      commit('projectSubTask', {});
    });
  },

  delete({ dispatch }, args) {
    projectSubTasksApi.deleteProjectSubTask(args).then(() => {
      dispatch('getList');
    });
  },
};
export const mutations = {
  projectSubTasks(state, payload) {
    state.projectSubTasks = payload;
  },
  projectSubTask(state, payload) {
    state.projectSubTask = payload;
  },
  filteredProjectSubTasks(state, payload) {
    state.filteredProjectSubTasks = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
